/**
 * Safe print utility - replaces document.write with Blob URL approach
 * Eliminates XSS risk from template string injection into document.write
 */
export function safePrint(htmlContent, title = 'Print') {
  const blob = new Blob([htmlContent], { type: 'text/html; charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const printWindow = window.open(url, '_blank');
  if (printWindow) {
    printWindow.onload = () => {
      printWindow.document.title = title;
      printWindow.print();
      URL.revokeObjectURL(url);
    };
  }
}
